function Questionary(container){
	var _this = this;
	this.container = $(container);
	this.work_box = this.container.find(".j-user-work");
	this.work_block = this.container.find(".work-block");
	this.fieldName = this.work_block.find("textarea").attr("name");
	$(".j-plus").live("click", function() {
		if(_this.work_block.find("textarea").attr("name") == _this.fieldName){
			_this.work_block.find("textarea").attr("name", _this.fieldName + "[]");
		}
		_this.work_box.append("<div class='work-block'><div class='textarea inline-block'><textarea name='" + _this.fieldName + "[]" +"'></textarea></div><div class='inline-block'><span class='j-plus'>+</span><span class='j-mines' style='display:none;'>&ndash;</span></div></div>");
		$(this).hide();
		$(this).parent().find(".j-mines").show();
	});
	$(".j-mines").live("click", function() {
		$(this).parents(".work-block").remove();
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/Questionary',[], function() {
		return Questionary;
	});
};
